export const API_TOKEN_ACCESS_OPTIONS = [
    { id: "read_write", value: "Leitura e escrita" },
    { id: "read_only", value: "Somente leitura" },
    { id: "custom", value: "Personalizado por recurso" },
]

export const API_TOKEN_SCOPE_RESOURCES = [
    ["additional-fields", "Campos adicionais"],
    ["chats", "Chats"],
    ["discards", "Descartes"],
    ["flags", "Marcadores"],
    ["funnels", "Funis e etapas"],
    ["leads", "Leads"],
    ["notes", "Notas"],
    ["origins", "Origens"],
    ["permissions", "Permissões"],
    ["products", "Produtos"],
    ["reasons-discards", "Motivos de descarte"],
    ["roles", "Cargos"],
    ["sales", "Vendas"],
    ["tasks", "Tarefas"],
    ["teams", "Equipes"],
    ["type-tasks", "Tipos de tarefa"],
    ["users", "Usuários"],
    ["voip", "Telefonia"],
    ["webhooks", "Webhooks"],
]

export const API_TOKEN_SCOPE_OPTIONS = API_TOKEN_SCOPE_RESOURCES.flatMap(([resource, label]) => [
    { id: `${resource}:read`, value: `${label} — leitura` },
    { id: `${resource}:write`, value: `${label} — escrita` },
])

export const API_TOKEN_EXPIRATION_OPTIONS = [
    { id: 1, value: "1 hora" },
    { id: 8, value: "8 horas" },
    { id: 24, value: "24 horas" },
    { id: 72, value: "3 dias" },
    { id: 168, value: "7 dias" },
    { id: 720, value: "30 dias" },
    { id: 2160, value: "90 dias" },
    { id: 8760, value: "1 ano" },
    { id: 0, value: "Nunca" },
]

export const getApiTokenAccessLabel = mode => ({
    read_only: "Somente leitura",
    custom: "Personalizado",
}[mode] || "Leitura e escrita")

export const getApiTokenAccessOptionsForEdit = token => {
    if (token?.access_mode === "read_only") return API_TOKEN_ACCESS_OPTIONS.filter(option => option.id === "read_only")
    if (token?.access_mode === "custom") return API_TOKEN_ACCESS_OPTIONS.filter(option => option.id === "custom")
    return API_TOKEN_ACCESS_OPTIONS
}

export const getApiTokenScopeOptionsForEdit = token => (
    token?.access_mode === "custom"
        ? API_TOKEN_SCOPE_OPTIONS.filter(option => (token.scopes || []).includes(option.id))
        : API_TOKEN_SCOPE_OPTIONS
)

export const getApiTokenExpirationDate = value => {
    let candidate = value
    for (let depth = 0; depth < 3 && candidate && typeof candidate === "object" && !(candidate instanceof Date); depth += 1) {
        candidate = candidate._d ?? candidate.$date ?? candidate.date ?? candidate.value
    }
    if (candidate === null || candidate === undefined || candidate === "") return null
    const date = candidate instanceof Date ? candidate : new Date(candidate)
    return Number.isFinite(date.getTime()) ? date : null
}

export const getApiTokenExpirationOptionsForEdit = (token, now = new Date()) => {
    const currentExpirationDate = token?.expires ? getApiTokenExpirationDate(token.expires_at) : null
    const currentExpiration = token?.expires ? currentExpirationDate?.getTime() : Infinity
    const currentTime = getApiTokenExpirationDate(now)?.getTime()
    if (!Number.isFinite(currentExpiration) || !Number.isFinite(currentTime)) return []
    return API_TOKEN_EXPIRATION_OPTIONS.filter(option => (
        option.id > 0 && currentTime + (option.id * 60 * 60 * 1000) < currentExpiration
    ))
}

export const getApiTokenFormValue = (token, defaultEnvironment = "live") => token ? {
    ...token,
    environment: token.environment || defaultEnvironment,
    access_mode: token.access_mode || "read_write",
    scopes: token.scopes || [],
    expire_in: "",
} : {
    environment: defaultEnvironment,
    access_mode: "read_write",
    scopes: [],
    expire_in: 720,
}
